// Stable inventory from the approved Alpha 2.5.0 Appendix A.
export const industryInventory = [
  {
    "id": "BB-MFG-01",
    "name": "Production planning and control",
    "description": "Connect demand, production plans, planned work orders, scheduling periods, and planned output requirements."
  },
  {
    "id": "BB-MFG-02",
    "name": "Shop-floor execution",
    "description": "Track work-order operations, operator assignments, progress events, output, scrap, and actual resource consumption."
  },
  {
    "id": "BB-MFG-03",
    "name": "Machine capacity and loading",
    "description": "Relate machines, capacity calendars, operation requirements, assigned loads, and scheduling constraints."
  },
  {
    "id": "BB-MFG-04",
    "name": "Purchase requisitions and indents",
    "description": "Capture material requests, requested quantities and dates, approvals, and fulfillment through stock issues or purchasing."
  },
  {
    "id": "BB-MFG-05",
    "name": "Purchasing and supplier orders",
    "description": "Model suppliers, purchase orders and lines, delivery commitments, receipts, and links to originating requisitions."
  },
  {
    "id": "BB-MFG-06",
    "name": "Incoming-material inspection",
    "description": "Connect received material lots, inspection requests, sample results, acceptance decisions, and stock dispositions."
  },
  {
    "id": "BB-MFG-07",
    "name": "In-process and finished-goods quality",
    "description": "Relate production stages and finished lots to checks, measured results, defects, corrective actions, and release decisions."
  },
  {
    "id": "BB-MFG-08",
    "name": "Customer orders",
    "description": "Connect customers, sales orders and lines, promised deliveries, demand allocation, and fulfillment status."
  },
  {
    "id": "BB-MFG-09",
    "name": "Inventory and warehouse movements",
    "description": "Track items and lots by warehouse location with receipts, issues, transfers, reservations, and counted adjustments."
  },
  {
    "id": "BB-MFG-10",
    "name": "Bills of materials and production routing",
    "description": "Model revisioned products, component requirements, operation sequences, and required resources."
  },
  {
    "id": "BB-MFG-11",
    "name": "Equipment maintenance",
    "description": "Relate equipment, maintenance plans, work orders, failures, labor, spare parts, and downtime."
  },
  {
    "id": "BB-MFG-12",
    "name": "Basic finance and production costing",
    "description": "Connect cost accounts, material and labor costs, overhead allocations, production cost records, and purchasing or sales references."
  },
  {
    "id": "BB-BNK-01",
    "name": "Customers and banking relationships",
    "description": "Extend shared Party records with customer relationships, account-holder roles, contacts, and relationship-manager assignments."
  },
  {
    "id": "BB-BNK-02",
    "name": "Account administration",
    "description": "Relate accounts, product definitions, holders, authorized signatories, status history, and servicing branches."
  },
  {
    "id": "BB-BNK-03",
    "name": "Deposits and term placements",
    "description": "Model deposit agreements, principal, term dates, rate periods, accrued-interest records, and maturity instructions."
  },
  {
    "id": "BB-BNK-04",
    "name": "Lending and repayment schedules",
    "description": "Connect loan agreements, borrowers, disbursements, repayment schedules, installments, and received repayments."
  },
  {
    "id": "BB-BNK-05",
    "name": "Payments and transfers",
    "description": "Model payment instructions, source and destination accounts, execution events, fees, and settlement references."
  },
  {
    "id": "BB-BNK-06",
    "name": "Card issuance and transactions",
    "description": "Relate card instruments, holders, linked accounts, authorization records, posted transactions, and disputes."
  },
  {
    "id": "BB-BNK-07",
    "name": "Treasury deals and positions",
    "description": "Capture treasury instruments, counterparties, deals, cash-flow schedules, settlement obligations, and position snapshots."
  },
  {
    "id": "BB-BNK-08",
    "name": "Collateral and security interests",
    "description": "Link pledged assets, owners, valuations, security agreements, and allocations to lending exposures."
  },
  {
    "id": "BB-BNK-09",
    "name": "Reconciliation and exceptions",
    "description": "Match internal entries with external statement items and record unresolved differences, assignments, and resolution events."
  },
  {
    "id": "BB-BNK-10",
    "name": "Branch cash and vault inventory",
    "description": "Track cash denominations, vault or teller locations, transfers, count sessions, and cash-stock adjustments."
  },
  {
    "id": "BB-BNK-11",
    "name": "Equipment and consumables inventory",
    "description": "Model branch equipment, custody, consumable stock, replenishment requests, maintenance references, and disposals."
  },
  {
    "id": "BB-BNK-12",
    "name": "Basic ledger and financial postings",
    "description": "Relate chart-of-account entries, journals, journal lines, accounting periods, and source references from banking operations."
  },
  {
    "id": "BB-CNF-01",
    "name": "Recipes and formula revisions",
    "description": "Connect confectionery products, recipe versions, ingredient quantities, units, yields, and effective dates."
  },
  {
    "id": "BB-CNF-02",
    "name": "Ingredient specifications",
    "description": "Describe ingredient items, composition characteristics, supplier-item references, and specification revisions."
  },
  {
    "id": "BB-CNF-03",
    "name": "Batch genealogy",
    "description": "Connect production batches to consumed ingredient lots, intermediate batches, finished lots, and quantity movements."
  },
  {
    "id": "BB-CNF-04",
    "name": "Production scheduling and execution",
    "description": "Relate demand, production runs, processing stages, equipment assignments, actual output, and losses."
  },
  {
    "id": "BB-CNF-05",
    "name": "Allergen declarations and handling",
    "description": "Model allergen reference terms, ingredient declarations, recipe-derived associations, handling requirements, and review records."
  },
  {
    "id": "BB-CNF-06",
    "name": "Quality checks and dispositions",
    "description": "Relate material or product lots to inspection plans, measured results, defects, acceptance, and rejection records."
  },
  {
    "id": "BB-CNF-07",
    "name": "Packaging and labeling",
    "description": "Connect finished products to packaging structures, label versions, pack sizes, and packaging-run consumption."
  },
  {
    "id": "BB-CNF-08",
    "name": "Shelf life and expiry tracking",
    "description": "Track lot production dates, assigned shelf life, expiry dates, storage-condition references, and disposition events."
  },
  {
    "id": "BB-CNF-09",
    "name": "Inventory and warehouse stock",
    "description": "Track ingredients, packaging, intermediates, and finished goods by lot and storage location with stock movements."
  },
  {
    "id": "BB-CNF-10",
    "name": "Purchasing and supplier receipts",
    "description": "Connect supplier agreements, ingredient or packaging orders, receipts, and invoice references."
  },
  {
    "id": "BB-CNF-11",
    "name": "Sales and distribution orders",
    "description": "Model customer orders, product quantities, lot allocations, dispatches, and returns."
  },
  {
    "id": "BB-CNF-12",
    "name": "Basic finance and product costing",
    "description": "Connect recipe cost estimates, actual batch costs, waste, inventory valuation records, and sales or purchasing postings."
  },
  {
    "id": "BB-AIR-01",
    "name": "Network and flight schedules",
    "description": "Relate airports, routes, schedule versions, flight legs, operating dates, and planned aircraft types."
  },
  {
    "id": "BB-AIR-02",
    "name": "Reservations and itinerary segments",
    "description": "Connect bookings, travelers, itinerary segments, booking status, and reserved service quantities."
  },
  {
    "id": "BB-AIR-03",
    "name": "Ticketing and fare documents",
    "description": "Model tickets, coupons, fares, taxes, issuance, exchanges, refunds, and reservation references."
  },
  {
    "id": "BB-AIR-04",
    "name": "Passenger handling",
    "description": "Relate passengers and flight segments to check-in records, seat assignments, boarding events, and service requests."
  },
  {
    "id": "BB-AIR-05",
    "name": "Aircraft fleet and configuration",
    "description": "Describe aircraft, type, ownership or lease references, cabin configurations, and service status history."
  },
  {
    "id": "BB-AIR-06",
    "name": "Crew assignments",
    "description": "Connect crew members, qualifications, duty records, roster versions, and assigned flight legs."
  },
  {
    "id": "BB-AIR-07",
    "name": "Aircraft maintenance",
    "description": "Relate aircraft and installed components to maintenance tasks, work packages, inspections, and service records."
  },
  {
    "id": "BB-AIR-08",
    "name": "Airport and turnaround operations",
    "description": "Track flight movements, stand assignments, turnaround activities, service providers, and operational timestamps."
  },
  {
    "id": "BB-AIR-09",
    "name": "Baggage tracking",
    "description": "Connect baggage items, tags, passenger journeys, handling events, transfers, and irregularity cases."
  },
  {
    "id": "BB-AIR-10",
    "name": "Air cargo",
    "description": "Model shipments, consignors, consignees, cargo documents, flight allocations, handling units, and delivery events."
  },
  {
    "id": "BB-AIR-11",
    "name": "Parts and catering inventory",
    "description": "Track stock items, lots or serials, station locations, reservations, receipts, issues, and replenishment requests."
  },
  {
    "id": "BB-AIR-12",
    "name": "Basic finance and revenue settlement",
    "description": "Relate sales documents, received payments, refunds, partner settlements, cost records, and ledger-posting references."
  },
  {
    "id": "BB-MED-01",
    "name": "Content catalogue",
    "description": "Relate works, titles, editions, genres, contributors, and editorial metadata."
  },
  {
    "id": "BB-MED-02",
    "name": "Production planning",
    "description": "Connect production projects, budgets, schedules, tasks, crews, and deliverables."
  },
  {
    "id": "BB-MED-03",
    "name": "Rights and licensing",
    "description": "Model rights holders, licensed works, agreements, permitted uses, territories, channels, and time windows."
  },
  {
    "id": "BB-MED-04",
    "name": "Publishing and release scheduling",
    "description": "Relate editions or content versions to releases, channels, scheduled dates, and publishing status."
  },
  {
    "id": "BB-MED-05",
    "name": "Distribution and delivery",
    "description": "Track content packages, delivery partners, destinations, delivery events, and acknowledgement records."
  },
  {
    "id": "BB-MED-06",
    "name": "Advertising campaigns and placements",
    "description": "Connect advertisers, campaigns, booked placements, creative assets, delivery records, and charge references."
  },
  {
    "id": "BB-MED-07",
    "name": "Subscriptions and entitlements",
    "description": "Relate subscribers, plans, subscriptions, access entitlements, renewal periods, and cancellation events."
  },
  {
    "id": "BB-MED-08",
    "name": "Audience engagement",
    "description": "Structure audience segments, content-consumption events, campaign responses, and aggregated measurement records."
  },
  {
    "id": "BB-MED-09",
    "name": "Digital asset library",
    "description": "Model media files, versions, renditions, storage references, technical metadata, and links to editorial works."
  },
  {
    "id": "BB-MED-10",
    "name": "Equipment inventory and bookings",
    "description": "Track cameras, studios, production equipment, custody, reservations, movements, and maintenance references."
  },
  {
    "id": "BB-MED-11",
    "name": "Purchasing and contracted services",
    "description": "Connect supplier or freelancer agreements, purchase orders, deliverables, acceptance, and invoice references."
  },
  {
    "id": "BB-MED-12",
    "name": "Basic finance and royalty settlements",
    "description": "Relate sales and advertising revenue, production costs, royalty calculation records, settlement statements, and ledger references."
  },
  {
    "id": "BB-HLT-01",
    "name": "Patient administration",
    "description": "Extend shared Person records with patient identifiers, administrative contacts, care-organization links, and record status."
  },
  {
    "id": "BB-HLT-02",
    "name": "Appointments and scheduling",
    "description": "Connect patients, practitioners, services, facilities, appointment slots, and attendance status."
  },
  {
    "id": "BB-HLT-03",
    "name": "Encounters and episodes",
    "description": "Relate patients to encounters, episode groupings, participating practitioners, locations, and administrative events."
  },
  {
    "id": "BB-HLT-04",
    "name": "Clinical service orders",
    "description": "Connect encounter requests, ordered services, requesting practitioners, fulfillment status, and result references."
  },
  {
    "id": "BB-HLT-05",
    "name": "Diagnostic specimens and results",
    "description": "Relate diagnostic requests, specimens, collection events, examinations, result observations, and report versions."
  },
  {
    "id": "BB-HLT-06",
    "name": "Medication ordering and dispensing records",
    "description": "Model medication items, order records, prescribing-party references, dispensing events, and fulfillment links."
  },
  {
    "id": "BB-HLT-07",
    "name": "Care resources and capacity",
    "description": "Relate facilities, rooms, beds, equipment, service units, allocations, and occupancy events."
  },
  {
    "id": "BB-HLT-08",
    "name": "Medical supply inventory",
    "description": "Track supplies and devices by item, lot or serial, storage location, receipt, issue, and stock adjustment."
  },
  {
    "id": "BB-HLT-09",
    "name": "Procurement and supplier receipts",
    "description": "Connect supply requisitions, suppliers, purchase orders, receipts, and invoice references."
  },
  {
    "id": "BB-HLT-10",
    "name": "Billing and payer claims",
    "description": "Relate charge items, service references, invoices, payer submissions, remittances, and patient balances."
  },
  {
    "id": "BB-HLT-11",
    "name": "Basic finance and cost centers",
    "description": "Connect accounting periods, cost centers, expenditure records, receipts, journal entries, and operational references."
  },
  {
    "id": "BB-HLT-12",
    "name": "Referrals and care coordination",
    "description": "Relate referral requests, originating and receiving providers, requested services, appointments, and referral outcomes."
  },
  {
    "id": "BB-PHM-01",
    "name": "Product and presentation catalogue",
    "description": "Relate pharmaceutical products, strengths or forms, presentations, pack sizes, and product versions."
  },
  {
    "id": "BB-PHM-02",
    "name": "Formulations and process definitions",
    "description": "Connect formulation revisions, ingredient quantities, process stages, resource requirements, and effective dates."
  },
  {
    "id": "BB-PHM-03",
    "name": "Material and supplier specifications",
    "description": "Relate raw or packaging materials, supplier-item references, specification versions, and review records."
  },
  {
    "id": "BB-PHM-04",
    "name": "Batch genealogy and traceability",
    "description": "Connect consumed material lots, manufacturing batches, intermediate output, finished lots, and quantity transformations."
  },
  {
    "id": "BB-PHM-05",
    "name": "Manufacturing orders and execution",
    "description": "Relate production orders, planned stages, equipment assignments, execution records, and actual consumption or output."
  },
  {
    "id": "BB-PHM-06",
    "name": "Laboratory samples and testing",
    "description": "Model sample requests, sampled lots, test definitions, measured results, report versions, and review events."
  },
  {
    "id": "BB-PHM-07",
    "name": "Batch review and release decisions",
    "description": "Connect batch documentation references, review tasks, decisions, authorized-party references, and disposition history."
  },
  {
    "id": "BB-PHM-08",
    "name": "Quality events and recalls",
    "description": "Relate deviations, complaints, investigations, affected lots, actions, and recall or withdrawal events."
  },
  {
    "id": "BB-PHM-09",
    "name": "Warehouse and controlled-stock inventory",
    "description": "Track material and product lots by location, stock status, storage-condition records, and stock movements."
  },
  {
    "id": "BB-PHM-10",
    "name": "Distribution and shipment tracking",
    "description": "Connect customer orders, lot allocations, shipments, transport-condition records, deliveries, and returns."
  },
  {
    "id": "BB-PHM-11",
    "name": "Procurement and supplier orders",
    "description": "Relate requisitions, supplier agreements, purchase orders, incoming deliveries, and invoice references."
  },
  {
    "id": "BB-PHM-12",
    "name": "Basic finance and batch costing",
    "description": "Connect material, production, testing, and distribution cost records to batches, invoices, and ledger references."
  },
  {
    "id": "BB-RTL-01",
    "name": "Product and assortment catalogue",
    "description": "Relate products, variants, categories, selling units, assortment assignments, and effective dates."
  },
  {
    "id": "BB-RTL-02",
    "name": "Suppliers and commercial terms",
    "description": "Connect supplier parties, offered items, agreements, lead-time records, and commercial-term versions."
  },
  {
    "id": "BB-RTL-03",
    "name": "Purchasing and replenishment orders",
    "description": "Relate purchase requests, orders, lines, expected receipts, and supplier commitments."
  },
  {
    "id": "BB-RTL-04",
    "name": "Warehouse operations",
    "description": "Model storage locations, receiving tasks, put-away tasks, picking work, packing units, and dispatch preparation."
  },
  {
    "id": "BB-RTL-05",
    "name": "Inventory and stock movements",
    "description": "Track item or lot quantities by location with receipts, reservations, transfers, issues, and counted adjustments."
  },
  {
    "id": "BB-RTL-06",
    "name": "Replenishment planning",
    "description": "Connect demand observations, stock targets, planning parameters, replenishment proposals, and resulting order references."
  },
  {
    "id": "BB-RTL-07",
    "name": "Sales and customer orders",
    "description": "Relate customer parties, sales channels, orders, line items, prices, and order status history."
  },
  {
    "id": "BB-RTL-08",
    "name": "Fulfillment and delivery",
    "description": "Connect order allocations, picking results, shipments, carriers, tracking events, and deliveries."
  },
  {
    "id": "BB-RTL-09",
    "name": "Returns and exchanges",
    "description": "Relate return requests, original sale lines, received items, inspection outcomes, replacements, and credit references."
  },
  {
    "id": "BB-RTL-10",
    "name": "Pricing and promotions",
    "description": "Model price lists, price periods, promotion rules, eligible products, applied discounts, and campaign references."
  },
  {
    "id": "BB-RTL-11",
    "name": "Payments and settlement",
    "description": "Connect payment attempts, received tenders, refunds, settlement batches, and sales-document references."
  },
  {
    "id": "BB-RTL-12",
    "name": "Basic finance and merchandise costing",
    "description": "Relate purchase costs, inventory valuations, sales margins, payable or receivable entries, and journal references."
  }
] as const;
